export function isReelCaptureMode(search: string) {
  return new URLSearchParams(search).get("reel-capture") === "1";
}
